import * as React from 'react'
import { FormInput } from '@hyper/forms'

export const TechnicalOrderRejectModalForm: React.FC = () => (
  <FormInput type="textarea" label="Powód cofnięcia" name="reason" />
)
